// extracted by mini-css-extract-plugin
export default {"socialMedia":"SocialMedia_socialMedia__owYCG","socialMediaItem":"SocialMedia_socialMediaItem__fzSiV"};